"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomString = exports.isAnalyticsSet = exports.getLanguage = exports.isCookieSet = exports.clearLocalStorage = exports.removeStorageItem = exports.getStorageItem = exports.setStorageItem = exports.sleep = exports.COOKIE_KEY = void 0;
exports.COOKIE_KEY = "master_cookie";

var sleep = function sleep(milliseconds) {
  var date = Date.now();
  var currentDate = null;

  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
};

exports.sleep = sleep;

var setStorageItem = function setStorageItem(key, data) {
  localStorage.setItem(key, data);
};

exports.setStorageItem = setStorageItem;

var getStorageItem = function getStorageItem(key) {
  return localStorage.getItem(key);
};

exports.getStorageItem = getStorageItem;

var removeStorageItem = function removeStorageItem(key) {
  localStorage.removeItem(key);
};

exports.removeStorageItem = removeStorageItem;

var clearLocalStorage = function clearLocalStorage() {
  localStorage.clear();
};

exports.clearLocalStorage = clearLocalStorage;

var isCookieSet = function isCookieSet(cookieKey) {
  var key = cookieKey ? cookieKey : exports.COOKIE_KEY;
  var cookie = (0, exports.getStorageItem)(key);

  if (!cookie) {
    return false;
  }

  return true;
};

exports.isCookieSet = isCookieSet;

var getLanguage = function getLanguage() {
  if (typeof window !== "undefined") {
    return navigator.language;
  }

  return null;
};

exports.getLanguage = getLanguage;

var isAnalyticsSet = function isAnalyticsSet(cookieKey) {
  var key = cookieKey ? cookieKey : exports.COOKIE_KEY;
  var cookie = (0, exports.getStorageItem)(key);

  if (!cookie) {
    return true;
  } else {
    var value = JSON.parse(cookie);
    return value.analytics === true;
  }
};

exports.isAnalyticsSet = isAnalyticsSet;

var randomString = function randomString(length) {
  // Declare all characters
  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"; // Pick characers randomly

  var str = "";

  for (var i = 0; i < length; i++) {
    str += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return str;
};

exports.randomString = randomString;